/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const seoState = {
    // meta: undefined, // UI suitable mapping of seo
    current: undefined,
    byWebpageGUID: {},
};
